export const iconFontAwesomeAccessibilityHandshakeAngle = (
	<i className="fa-solid fa-handshake-angle"></i>
);
